import { missionWritePermissionPending } from './mission-write-pending'

/** The removal committed; permission cleanup may still be pending. */
export interface MissionRemovalResult {
  permissionPending: boolean
}

interface MissionRemovalClient {
  delete(path: string): Promise<unknown>
}

async function requestRemoval(client: MissionRemovalClient, path: string, missionId: string): Promise<MissionRemovalResult> {
  try {
    await client.delete(path)
    return { permissionPending: false }
  } catch (error) {
    if (!missionWritePermissionPending(error, missionId)) throw error
    return { permissionPending: true }
  }
}

export function requestMissionDeletion(client: MissionRemovalClient, missionId: string): Promise<MissionRemovalResult> {
  return requestRemoval(client, `missions/${missionId}`, missionId)
}

export function requestMissionAgentRemoval(client: MissionRemovalClient, missionId: string, agentId: string): Promise<MissionRemovalResult> {
  return requestRemoval(client, `missions/${missionId}/agents/${agentId}`, missionId)
}
